import styled from "styled-components";

export const PreviewWrapper = styled.div`
  position: relative;
  width: 80%;
  height: ${({ theme }) => theme.CONSTANTS.XH * 62}px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  overflow: hidden;

  @media (min-width: 1025px) {
    height: ${({ theme }) => theme.CONSTANTS.XH * 65}px;
  }
`;

export const QrContainer = styled.div<{ $borderColor?: string }>`
  padding: 4px;
  border: 4px solid ${({ $borderColor }) => $borderColor || "transparent"};
  border-radius: 20px;
  z-index: 2;
  display: flex;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 24}px;
`;

export const Wallpaper = styled.img`
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  z-index: 1;
`;
